module.exports = __webpack_public_path__ + "static/media/main_green_logo.f1db57da.png";